export default "__VITE_ASSET__lLEAo14G__"